module.exports = __webpack_public_path__ + "static/media/termsAndConditions.3ca61e6b.pdf";